import React, {useEffect, useRef, useState} from "react";

import {Route, Switch, useHistory, useParams, useRouteMatch} from "react-router-dom";

import {useDispatch, useSelector} from "react-redux";

import TextareaAutosize from "@mui/material/TextareaAutosize";

import {loading, loadPatientById, patient, removePatient, setProcessing} from '../../store/reducers/patient';
import {
    documents, getGroupId,
    loadDocumentsForPatientById, loading as DocumentLoading,
    regroupStudies,
    reorderStudyDocuments,
    setExpanded, setSelectedDocuments,
    studies,
    studiesGroup, studiesUngrouped,
} from '../../store/reducers/documents';
import {
    cloneCurrentPref,
    patient as patientPreferences,
    patientCurrent as patientCurrentPreferences,
    savePref,
    setPatientCurrentPreference
} from "../../store/reducers/preferences";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

import {
    BinIcon,
    CancelIcon,
    CompareIcon, FilterIcon2, FilterIcon3, FinalAnnotationIcon,
    SaveIcon2,
    SelectedIcon, StudyListIcon, StudyListIcon2,
    UnselectedIcon,
    UploadIcon,
} from '../../components/icons/icons';
import DeleteIcon from '@mui/icons-material/Delete';
import {loadPatientWithDocuments} from "../../util/loaders";
import DownloadIcon from '@mui/icons-material/Download';
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from "react-i18next";

import UploadIMAGE from "../../controls/uploadIMAGE";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";

import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import PerfectScrollbar from "react-perfect-scrollbar";

import API from "../../app/api";

import _ from "lodash";
import moment from "moment";
import clsx from "clsx";

import config from "../../app/config";

import Thumbnail from "./thumbnail";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import SaveIcon from "@mui/icons-material/Save";
import PhotoSizeSelectLargeIcon from "@mui/icons-material/PhotoSizeSelectLarge";
import PhotoIcon from "@mui/icons-material/Photo";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";

import MessageBox from "../../util/messageBox";
import {
    hasPermission,
    Permissions, setVipPatientGranted,
    user, vipPatientGranted,
} from '../../store/reducers/user';
import {globalVariable, setGlobalVariable, setSnackbar} from '../../store/reducers/globals';
import $ from "jquery";
import useOpenState from "../../hooks/useOpenState";
import AgyleDialog from "../../components/modal/agyleDialog";
import StudiesList from "./studiesList";
import {DialogActions, Drawer, InputLabel, OutlinedInput, Select, TextField} from "@mui/material";
import Chip from "@mui/material/Chip";
import FormControl from "@mui/material/FormControl";
import {FilterAddButton} from "../holding/filterAddButton";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
import * as mime from 'react-native-mime-types';
import * as contentDisposition from 'content-disposition-header';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuList from '@mui/material/MenuList';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import Formatter from '../../util/formatter';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';
import AgyleTextField from '../../components/ui/fields/agyleTextField';
import {EyonixFilterAddButton} from './eyonixFilterAddButton';
import AgyleSelectField from '../../components/ui/selector/agyleSelectField';
import {loadingPref} from '../../store/reducers/additionalData';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SearchIcon from '@mui/icons-material/Search';
import SwitchT from '@mui/material/Switch';
import ThumbnailPrev from './thumbnailPrev';

const useStyles = makeStyles((theme) => ({
    spaceMark: {
        fontSize: "xx-small",
        color: theme.palette.mode === "dark" ? "darkgoldenrod" : "darkgoldenrod"
    },
    emptyMark: {
        color: theme.palette.mode === "dark" ? "darkgoldenrod" : "darkgoldenrod"
    },
    noCapitalize: {
        textTransform: "none"
    },
    noRecordsInfo: {
        textAlign: "center",
        fontSize: "200%",
        marginTop: "25vh",
        color: theme.palette.mode === "dark" ? "#aaa" : "#aaa"
    },
    studiesLabel: {
        fontSize: "14px",
        padding: "25px 0 10px 25px",
        fontWeight: "bold"
    },
    dialogContentStyle: {
        backgroundColor: theme.palette.mode === "dark" ? "#3D3E40" : "#f2f2f2"
    },
    titleStyleDialog: {
        backgroundColor: theme.palette.mode === "dark" ? "#3D3E40 !important" : "#f2f2f2",
    },
    menuItemChip: {
        borderRadius: "38px",
        border: "1px solid #A4A7AB",
        background: "#3D3E40",
        width: 100,
        height: 32,
        fontSize: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        "&:hover": {
            background: "#A4A7AB"
        },
        "&.selected": {
            background: "white",
            color: "black",
            fontWeight: 700
        }
    },
    clearButton: {
        borderRadius: "38px",
        border: "1px solid white",
        background: "white",
        width: 100,
        color: "black",
        height: 32,
        fontSize: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        "&:hover": {
            background: "#A4A7AB",
            border: "1px solid #A4A7AB",
        },
    },
    filterNameInModal: {
        color: "#FFF",
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "normal",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        height: 32,
    },
    modalBottomButtons: {
        display: "inline-flex",
        gap: "10px",
        justifyContent: "flex-end",
        position: "absolute",
        bottom: "8px",
        height: "35px",
        right: "20px"
    },
    groupTitle: {
        margin: "10px 20px",
        fontSize: theme.typography.h5.fontSize,
        userSelect: "none",
    },
    groupWithParent: {
        paddingLeft: 10,
        fontSize: theme.typography.h6.fontSize,
    },
    groupExpanded: {
        fontWeight: "bold",
    },
    expandedStatus: {
        display: "inline-block",
        float: "right",
    },
    studyElement: {
        margin: "10px 20px",
    },
    studyElementPaper: {
        // padding: "10px 10px 10px 20px",
        // padding: 0,
        padding: "1px 2px",
        // lineHeight: 0,
        fontWeight: 300,
    },

    studyElementContentHeader: {
        userSelect: "none",
        cursor: "pointer",
        padding: "3px 6px",
        // minHeight: 28,
    },
    studyElementContentHeaderCollapsed: {
        minHeight: 28,
    },
    studyHeader: {
        background: "#626466"
    },
    studyElementContent: {
        display: "inline-flex",
        width: "calc(100% - 24px - 24px - 8px)",
    },
    colorCoded: {
        width: 14,
        height: 14,
        display: "inline-block",
        borderRadius: "50%",
        marginRight: 10,
        marginTop: 2,
        position: "relative",
        top: 2,
    },
    colorCodedEx: {
        width: 14,
        height: 14,
        display: "inline-block",
        marginRight: 6,
        marginTop: 2,
        position: "relative",
        top: 2,
    },
    colorCodedSelectable: {
        transform: "scale(1.2)",
        width: "14px !important",
        height: "14px !important"
    },
    studyHeaderText: {
        display: "inline-block",
        // verticalAlign: "top",
        // marginTop: 2,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        paddingRight: 5,
        paddingLeft: 5
    },
    studyHeaderDate: {
        // width: 150
        width: "20%",
    },
    studyHeaderStudy: {
        // width: 150
        width: "40%",
    },
    studyHeaderLocation: {
        width: "20%",
        textAlign: "right",
    },
    studyHeaderOperator: {
        width: "20%",
        textAlign: "right",
        // float: "right",
    },
    // studyHeaderSpacing: {
    //     marginLeft: 50
    // }
    smallerIcon: {
        width: 14,
        height: 14,
    },
    smallerIconRed: {
        width: 14,
        height: 14,
        color: "#ff7676"
    },
    popper: {
        zIndex: theme.zIndex.drawer - 1,
    },
    smallerIcon2: {
        width: 18,
        height: 18,
    },
    removeIcon: {
        width: 15,
        height: 15,
    },
    sizeIcon: {
        width: 20,
        height: 20,
        color: "white"
    },

    selectedToolbox: {
        // float: "left",
        // position: "absolute",
        //  margin: "-8px 20px 0 50px",
        // lineHeight: "30px",
    },
    selectedToolboxText: {
        display: "inline",
        position: "relative",
        top: 1,
        fontSize: "90%",
    },
    groupingSection: {
        textAlign: "center",
        margin: "20px 0 10px",
    },
    buttonSelector: {
        borderRadius: 50,
        backgroundColor: theme.palette.grey["300"],
        color: "rgba(0, 0, 0, 0.87)",
        margin: "0 5px",
    },
    buttonSelectorGroups: {
        margin: "10px 20px 5px",
        fontSize: "110%",
        padding: "4px 15px",
        fontWeight: "bold",
    },
    buttonSelectorSelected: {
        color: theme.palette.grey["300"],
        backgroundColor: "rgba(0, 0, 0, 0.87)",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.87)",
        },
    },
    filtersBlock: {
        //     position: "absolute",
        right: 20
    },
    filtersBlockGroup: {
        // marginLeft: "20px !important",
    },
    filterItem: {
        display: "inline-block",
        margin: "0 5px",
    },
    groupedButton: {
        border: "1px solid white",
        padding: 5,
        fontSize: 13,
        height: 36,
        minWidth: 110,
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        borderRadius: 25,
        margin: "0px 2px 0 2px",
    },
    menuItem: {
        fontSize: "10px"
    },
    filterButton: {
        height: "20px"
    },
    button: {
        height: "38px",
        width: "30px",
        color: "white"

        //      marginLeft: "20px"
    },
    SwitchTrack: {

    },
    switchContainer: {
        display: "inline-flex",
        alignItems: "center",
        fontSize: "14px",
        gap: "3px",
        marginLeft: 10
    },
    buttonStudies: {
        //  height: "20px",
        width: "150px",
        float: "right"
    },
    icon: {
        fontSize: "15px"
    },
    test: {
        marginLeft: "0"
    },
    reasonText: {
        width: '100%',
    },
    noPatient: {
        fontSize: 20,
        textAlign: 'center',
        marginTop: 50
    },
    avatarCustom: {
        width: "auto !important",
        height: "auto !important",
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 15,
        color: "#000000",
        background: "#dd8d17"
    },
    filterBox: {
        border: "1px solid grey",
        // padding: 5,
        borderRadius: 15,
        margin: "0px 2px 0 2px",
        width: "calc(20% - 4px)",
        float: "left",
    }
}));

function Patient() {
    const match = useRouteMatch();
    const classes = useStyles();
    const { t, i18n } = useTranslation();

    // dispatch(setPatient({_id: "ABC"}))
    // console.error("patientObject REFRESH");

    return (
        <>
            <Switch>
                <Route path={`${match.path}/:patientId`}>
                    { (process.env.BUILD_MODULE === "main" || process.env.BUILD_MODULE === "eyonix") ?
                        <PatientVIPEyonixGuard forwardComponent={<PatientDetails />} /> : <PatientDetails />}
                </Route>
                {/*ALSO POSSIBLE*/}
                {/*<Route path="/:id" children={<Child />} />*/}
                <Route path={match.path}>
                    {/* TODO: search ... */}
                    <h3>Please select a patient.</h3>
                </Route>
            </Switch>
        </>
    );
}

export function PatientVIPEyonixGuard({forwardComponent, patientIdOpenFromAdmin}) {
    const { t } = useTranslation();
    let { patientId } = useParams();
    if(patientIdOpenFromAdmin) patientId = patientIdOpenFromAdmin;
    const dispatch = useDispatch();
    const history = useHistory();
    const patientObject = useSelector(patient);
    const userObj = useSelector(user);
    const canAccessVipPatient = dispatch(hasPermission(Permissions.CAN_VIEW_VIP));
    const tmpCanAccessVipPatient = dispatch(vipPatientGranted(patientId));
    const canAccessVipPatientOnRequest = dispatch(hasPermission(Permissions.CAN_VIEW_VIP_SUPERVISED));
    const [isVipPatientAccessRequestDialogOpen, openVipPatientAccessRequestDialog, closeVipPatientAccessRequestDialog] = useOpenState(false, true);
    const [openVipPatientReason, setOpenVipPatientReason] = useState("");
    const [vipPatientAccessGranted, setVipPatientAccessGranted] = useState(canAccessVipPatient || tmpCanAccessVipPatient);
    const [noAccessMessage, setNoAccessMessage] = useState("")
    const handleOpenVipPatientReasonAudit = () => {
        API.eyonixAudit(76, {patientId: patientId, documentId: "", data: openVipPatientReason}).then((success) => {
            closeVipPatientAccessRequestDialog();
            setOpenVipPatientReason("");
            dispatch(loadPatientById(patientId));
            dispatch(setVipPatientGranted(patientId));
            setVipPatientAccessGranted(true);
        }, (error) => {
            closeVipPatientAccessRequestDialog();
            setOpenVipPatientReason("");
            setVipPatientAccessGranted(false);
            setNoAccessMessage( t("Cant save reason to audit. Can't open vip patient record."));
            openVipPatientAccessDeny();
        });
    }
    const [isVipPatientAccessDeny, openVipPatientAccessDeny, closeVipPatientAccessDeny] = useOpenState(false, true);
    const handleOpenVipPatientAccessDeny = () => {
        closeVipPatientAccessDeny();
        history.goBack();
    }

    const [renderOutput, setRenderOutput] = useState(false);

    useEffect(() => {
        if(patientId && (!patientObject || patientObject.hospitalNumber != patientId)){
            dispatch(loadPatientById(patientId));
        }
    }, []);

    useEffect(() => {
        if(patientId && (!patientObject || patientObject.hospitalNumber != patientId)){
            dispatch(loadPatientById(patientId));
        }
    }, [patientIdOpenFromAdmin]);

    useEffect(()=>{
        if(patientObject) {
            let vipPatientAccessGrantedTMP = vipPatientAccessGranted;
            if (canAccessVipPatient || tmpCanAccessVipPatient) {
                setVipPatientAccessGranted(true);
                vipPatientAccessGrantedTMP = true;
            }
            if (patientObject?.hospitalNumber == patientId && userObj.hasOwnProperty("userName")) {
                if (!patientObject.vip || patientObject.vip && vipPatientAccessGrantedTMP) {
                    setRenderOutput(true);
                } else {
                    setRenderOutput(false);
                    dispatch(removePatient());
                    if (patientObject.vip && canAccessVipPatientOnRequest) {
                        setOpenVipPatientReason("");
                        openVipPatientAccessRequestDialog();
                    } else {
                        setNoAccessMessage(t("No access granted. Can't open vip patient record."));
                        openVipPatientAccessDeny();
                    }
                }
            } else {
                setRenderOutput(true);
            }
        } else {
            if(patientId == config.modules.holdingPen.name){
                setRenderOutput(true);
            }
        }
    }, [patientObject?.hospitalNumber, vipPatientAccessGranted, userObj?.userName, canAccessVipPatient, tmpCanAccessVipPatient]);

    return (
        <>
            {renderOutput && forwardComponent}

            <AgyleDialog
                open={isVipPatientAccessRequestDialogOpen}
                onClose={() => {
                    closeVipPatientAccessRequestDialog();
                    history.goBack();
                }}
                width="md"
                fullWidth
                title={t("Reason to access VVIP patient record")}
                onSave={handleOpenVipPatientReasonAudit}
                disableSubmit={openVipPatientReason.length < 5}
            >
                <Grid container spacing={2} direction="row" justifyContent="flex-start" alignItems="center">
                    <Grid item xs={12}>
                        <AgyleTextField
                            shrink
                            size="small"
                            variant="outlined"
                            className={"custom-dt"}
                            placeholder={t("Reason...")}
                            onChange={(e) => setOpenVipPatientReason(e.target.value)}
                            value={openVipPatientReason}
                            style={{width: "100%", margin: 0}}
                        />
                    </Grid>
                </Grid>
            </AgyleDialog>

            <MessageBox
                onClose={()=>handleOpenVipPatientAccessDeny()}
                title={t("No Access")}
                haveAccept={{no: t("Close")}}
                message={noAccessMessage}
                open={isVipPatientAccessDeny}
                warning
            />
        </>
    );
}

export function PatientDetails(props) {
    let { patientId } = useParams();
    if(props.patientIdOpenFromAdmin) patientId = props.patientIdOpenFromAdmin;
    const dispatch = useDispatch();
    const history = useHistory();

    // TODO: this should be probably some sort of util function - needs to be almost in every component
    useEffect(() => {
        // TODO: export to some static element
        window._scrollBarRef.updateScroll();
    });

    const classes = useStyles();
    const { t, i18n } = useTranslation();

    // FIXME: we may want to expose those below into props because it may be useful to have more than one list
    //  instance at one point in UCR

    const patientObject = useSelector(patient);
    const documentsObject = useSelector(documents);
    const studiesObject = useSelector(studies);
    const studiesUngroupedObject = useSelector(studiesUngrouped);
    const studiesGroupObject = useSelector(studiesGroup);
    const patientPreferencesObject = useSelector(patientPreferences);
    const patientCurrentPreferencesObject = useSelector(patientCurrentPreferences);


    const [documentsRelationship, setDocumentsRelationship] = useState(null);
    const [selectedThumbs, setSelectedThumbs] = useState([]);
    const [canDelete, setCanDelete] = React.useState(false);
    const [message, setMessage] = React.useState(null);
    const [messageTitle, setMessageTitle] = React.useState(t("Information"));

    const [thumbnailSize, setThumbnailSize] = React.useState("small");

    const [dialogTitle, setDialogTitle] = React.useState("");
    const [dialogMessage, setDialogMessage] = React.useState("");
    const [dialogDeleteReason, setDialogDeleteReason] = React.useState("");

    const [uploadVisible, setUploadVisible] = React.useState(false);

    const scrollbarReferences = useRef([]);

    const loadingPatientObject = useSelector(loading);
    const loadingDocumentObject = useSelector(DocumentLoading);
    const userObject = useSelector(user);

    const scrollPositionEyonix = useSelector(globalVariable("scrollPositionEyonix"));
    const [filters, setFilters] = React.useState(config.modules.patient.filters);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const studiesListRender = [];
    // const [userCanUpload, setUserCanUpload] = React.useState(false);
    // const [userCanDownload, setUserCanDownload] = React.useState(false);
    // const [userIsAdmin, setUserIsAdmin] = React.useState(false);

    const [isStudiesListOpen, openStudiesList, closeStudiesList] = useOpenState(false, true);
    const [isConfirmSaveFinalOpen, openConfirmSaveFinal, closeConfirmSaveFinal] = useOpenState(false, true);
    const [isConfirmSaveUnfinalOpen, openConfirmSaveUnfinal, closeConfirmSaveUnfinal] = useOpenState(false, true);
    const [isConfirmHoldingPenBackOpen, openConfirmHoldingPenBack, closeConfirmHoldingPenBack] = useOpenState(false, true);

    const canViewPatientRecord = dispatch(hasPermission(Permissions.CAN_VIEW_PATIENT_RECORD));
    const canDeleteDocument = dispatch(hasPermission(Permissions.CAN_DELETE_DOCUMENT));
    const canPrintAndDownloadDocument = dispatch(hasPermission(Permissions.CAN_PRINT_AND_DOWNLOAD));
    const canModifyDocument = dispatch(hasPermission(Permissions.CAN_MODIFY_PATIENT_RECORD));
    const canBackDocumentToHolding = dispatch(hasPermission(Permissions.CAN_MOVE_TO_HP));

    const handleUpload = (e) => {
        setUploadVisible(true);
    }
    const uploadCancel = () => {
        setUploadVisible(false);
    };
    const uploadFinished = () => {
        setUploadVisible(false);

        dispatch(loadDocumentsForPatientById(t, patientObject.hospitalNumber, true));
    };

    useEffect(() => {
        // console.log("documentsObject", documentsObject);
        if (documentsObject && documentsObject.__data) {
            for (let document of documentsObject.__data) {
                // console.log(document);
                if (document.metadata && document.metadata.relatedDocument) {
                    // console.log("document.metadata.relatedDocument", document.metadata.relatedDocument, document);
                }
            }
        } else {
            setDocumentsRelationship(null);
        }
    }, [documentsObject]);

    const analiseStringOptionData = (dOperatorName) => {
        if(dOperatorName == null) {
            return [null, 0, 0];
        }
        else if(dOperatorName == "") {
            return ["<empty>", 0, 0];
        }
        if(dOperatorName.replaceAll(" ", "").length == 0){
            return ["", dOperatorName.length, 0];
        }
        else {
            let spacesBefore = 0;
            let foundLetterBegin = false;
            let i = 0;
            let spacesAfter = 0;
            let j = dOperatorName.length - 1;
            let foundLetterEnd = false;
            while(i < j && !(foundLetterBegin && foundLetterEnd)) {
                if(!foundLetterBegin)
                    if(dOperatorName[i] === " ") {spacesBefore++;i++} else foundLetterBegin = true;
                if(!foundLetterEnd)
                    if(dOperatorName[j] === " ") {spacesAfter++;j--} else foundLetterEnd = true;
            }
            return [dOperatorName.slice(i, dOperatorName.length - spacesAfter), spacesBefore, spacesAfter];
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(loadPatientWithDocuments(patientId, patientObject, dispatch, t),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [patientId, patientObject]);

    const formatDate = (date) => {
        if (!date) {
            return t("Date unspecified");
        }
        const mmt = moment(date);
        return (
            <span>
                <strong>{mmt.format(config.secondaryDateFormat)}</strong>
                {mmt.format(", " + config.secondaryDateFormatSupliment)}
            </span>
        );
    };


    const saveScrollPosition = () => {
        const scrollDomObj = $('#studiesList');
        dispatch(setGlobalVariable({
            name: "scrollPositionEyonix",
            value: scrollDomObj.scrollTop(),
        }));

        const scrollDomObjSmartFilters = $('#smartFiltersList');
        if(scrollDomObjSmartFilters && props.adminPageMode) {
            dispatch(setGlobalVariable({
                name: "smartFiltersSettings",
                value: {
                    scroll: scrollDomObjSmartFilters.scrollTop(),
                    mode: props.adminPageMode
                },
            }));
        }
    }

    const saveContext = () => {
        dispatch(setGlobalVariable({
            name: "openInAdminContext",
            value: props.hasOwnProperty('patientIdOpenFromAdmin'),
        }));
    }


    useEffect(()=>{
        setTimeout(() => {
            const scrollDomObj = $('#studiesList');
            scrollDomObj?.scrollTop(scrollPositionEyonix);
        }, 500);
    },[]);

    useEffect(()=>{
        if(!loadingDocumentObject) {
            setTimeout(() => {
                const scrollDomObj = $('#studiesList');
                scrollDomObj?.scrollTop(scrollPositionEyonix);
            }, 500);
        }
    },[loadingDocumentObject]);

    const openDocument = (document) => () => {
        saveScrollPosition()
        saveContext();

        /*
        API.getMetadataForDocuments(patientId, [document.__id]).then(metadata => {
            let meta = metadata[document.__id];
            console.warn("metadata", meta);
            let modality = (meta && meta.dicom && meta.dicom["00080060"] && meta.dicom["00080060"].Value) ? meta.dicom["00080060"].Value[0] : null;
            console.log("modality", modality);
        });
        */

        // http://localhost:8282/view/D557367/TEST1,TEST2
        let documentsInfo = {
            mode: "split", // split || tabs
            documents: [document.__id],
            odosType: document.metadata.procedureName,
            studyId: document.metadata.studyId || getGroupId(document),
            // documents: [document.__id, document.__id],
            // documents: ["U1JDX1VOSVRZU1RPUkUvNjAzNzY3Yzc2YTgzMDYwMDAxNzJlZDgy", "U1JDX1VOSVRZU1RPUkUvNWY2YzgzYmM5MDA5MDkwMDAxZmZiYmJj"],
            // documents: ["U1JDX1VOSVRZU1RPUkUvNjAzNzY3Yzc2YTgzMDYwMDAxNzJlZDgy", "U1JDX1VOSVRZU1RPUkUvNWY2YzgzYmM5MDA5MDkwMDAxZmZiYmJj", "U1JDX1VOSVRZU1RPUkUvNjAzNzY3Yzc2YTgzMDYwMDAxNzJlZDgy", "U1JDX1VOSVRZU1RPUkUvNWY2YzgzYmM5MDA5MDkwMDAxZmZiYmJj"],
        };
        documentsInfo = JSON.stringify(documentsInfo);
        documentsInfo = btoa(documentsInfo);

        history.push(`/view/${patientId}/${documentsInfo}`);
    };

    const openGroupForCompare = () => {
        saveScrollPosition()
        const documentsToOpen = [];
        const selectedThumbsSorted = [];
        _.forEach(selectedThumbs, st => selectedThumbsSorted.push(st));

        var map = { L: 1, R: 2, B: 3, null: 4};
        selectedThumbsSorted.sort(function(x, y){
            if(x.metadata && y.metadata)
                return map[x.metadata.laterality] - map[y.metadata.laterality];
            else
                return 1;
        });

        _.forEach(selectedThumbsSorted, st => {
            if (!st.__isStudy) {
                documentsToOpen.push(st.__id)
            } else {
                documentsToOpen.push(st.documents[0].__id);
            }
        });

        let documentsInfo = {
            mode: "split", // split || tabs
            documents: documentsToOpen,
        };
        documentsInfo = JSON.stringify(documentsInfo);
        documentsInfo = btoa(documentsInfo);

        history.push(`/view/${patientId}/${documentsInfo}`);
    };
    const openGroupAsTabs = () => {
        alert("openGroupAsTabs");
    };

    const deleteSelectedDocuments = () => {
        setCanDelete(true);
    };

    const anchorRefDownload = React.useRef(null);

    const [isDownloadDropDownOpen, openDownloadDropDown, closeDownloadDropDown] = useOpenState(false, true);


    const handleToggle = () => {
        if(isDownloadDropDownOpen)
            closeDownloadDropDown()
        else
            openDownloadDropDown()
    };

    const handleBackToHoldingPen = async () => {
        let promises = [];

        selectedThumbs.forEach((thumb) => {
            if(thumb.__isStudy){
                thumb.documents.forEach((doc)=>{
                    promises.push(API.backDocumentToHoldingPen(doc.externalId))
                })
            } else {
                promises.push(API.backDocumentToHoldingPen(thumb.externalId))
            }
        })

        Promise.all(promises).then((res)=> {
            const counts = res.reduce(
                (acc, item) => {
                    if (item.status === "OK") acc.ok++;
                    else acc.other++;
                    return acc;
                },
                { ok: 0, other: 0 }
            );

            if(counts.other > 0){
                dispatch(setSnackbar({type: 'error', message: `${counts.ok} documents back to Holding Pen, ${counts.other} have not back to Holding Pen`}));
            } else {
                dispatch(setSnackbar({type: 'success', message: 'All documents back to Holding Pen'}));
            }
            dispatch(loadDocumentsForPatientById(t, patientId, true));

        }).finally(()=>{
            setSelectedThumbs([]);
            closeConfirmHoldingPenBack();
        });
    }

    const downloadSelectedDocuments = () => {
        if(canPrintAndDownloadDocument) {
            console.log("selectedThumbs", selectedThumbs);
            if (selectedThumbs.length === 1 && !selectedThumbs[0].__isStudy) {
                API.downloadDocument(selectedThumbs[0].__id, {nameType: "filename"}).then(response => {

                    let type = mime.extension(response.data.type);
                    let fileName = selectedThumbs[0].__id
                    if(type) {
                        fileName += "." + type;
                    }

                    const cd = response.request.getResponseHeader("Content-Disposition");
                    if (cd) {
                        const cdParsed = contentDisposition.parse(cd);
                        if (cdParsed.parameters.filename) {
                            fileName = cdParsed.parameters.filename;
                        }
                    }

                    if(response.data.type === "application/dicom") {
                        fileName += ".dcm";
                    }

                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();

                });
            } else {
                let documents = [];

                selectedThumbs.forEach((thumb) => {
                    if (thumb.__isStudy) {
                        thumb.documents.forEach((doc) => {
                            documents.push(doc.__id)
                        })
                    } else {
                        documents.push(thumb.__id)
                    }
                });


                API.downloadDocuments(documents).then(response => {
                    let type = mime.extension(response.data.type);
                    if(response.data.type === "application/dicom") {
                        type = "dcm"
                    }
                    let fileName = selectedThumbs[0].__id + "." + type;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                });
            }
        }


    };

    const printImageWithAnnotations = () => {
        let docToPrint = selectedThumbs[0];

        const URL = `${config.apiUrl}/patients/${patientObject.hospitalNumber}/documents/${docToPrint.__id}/pages/1/preview/hi/image?Authorization=${window.keycloak ? window.keycloak.token : window.auth.token}`;

        const w = window.open('', '');
        w.document.write(`<html><head> <title>Patient - ${docToPrint.metadata.patientId}</title>`);
        w.document.write('</head><body >');
        w.document.write('<img id="print-image-element" width="100%" src="'+URL+'"/>');
        w.document.write('<script>var img = document.getElementById("print-image-element"); img.addEventListener("load",function(){ window.focus(); window.print(); window.document.close(); window.close(); }); </script>');
        w.document.write('</body></html>');
    }

    const downloadSelectedPDFDocuments = (type) => {
        if(canPrintAndDownloadDocument) {
            let printUrl = config.printUrl;

            if (printUrl) {
                let data = {
                    contentDisposition: type,
                    type: "doc",
                    noWatermark: true,
                    patient: {
                        patientId: patientObject.hospitalNumber,
                        nhsNumber: patientObject.nhsNumber,
                        firstName: patientObject.firstName,
                        middleName: patientObject.middleName,
                        familyName: patientObject.familyName,
                        title: patientObject.title,
                        dob: moment(patientObject.dob).format("DD/MM/YYYY"),
                        gender: patientObject.gender,
                        addressLine1: patientObject.addressLines[0],
                        addressLine2: patientObject.addressLines[1],
                        addressLine3: patientObject.addressLines[2],
                        addressLine4: patientObject.addressLines[3],
                        postCode: patientObject.postCode,
                        homeTelephone: patientObject.homeTelephone,
                        workTelephone: patientObject.workTelephone,
                        mobileTelephone: patientObject.mobileTelephone,
                        email: patientObject.emailAddress,
                    },
                    tabs: []
                };


                selectedThumbs.forEach((thumb) => {
                    if (thumb.__isStudy) {
                        let documents = [];
                        thumb.documents.forEach((doc) => {
                            documents.push({
                                id: doc.__id,
                                startDate: moment(doc.startDate).format("DD/MM/YYYY HH:mm"),
                                dateSort: moment(doc.startDate).format("DD/MM/YYYY HH:mm"),
                                type: doc.docType ? doc.docType.name : "UNK",
                                pages: doc.pageCount
                            })
                        })
                        data.tabs.push({
                            name: `Study ${thumb.study}`,
                            documents: documents
                        })
                    } else {
                        data.tabs.push({
                            name: `Document - ${thumb.docType?.name ? thumb.docType?.name : thumb.metadata?.procedureName}`,
                            documents: [{
                                id: thumb.__id,
                                startDate: moment(thumb.startDate).format("DD/MM/YYYY HH:mm"),
                                dateSort: moment(thumb.startDate).format("DD/MM/YYYY HH:mm"),
                                type: thumb.docType?.name ? thumb.docType?.name : thumb.metadata?.procedureName,
                                pages: thumb.pageCount
                            }]
                        })
                    }
                });

                var dataJSON = JSON.stringify(data);

                var form = document.createElement('form');
                form.setAttribute('method', 'post');
                form.setAttribute('action', printUrl);
                form.setAttribute("target", "_blank");

                var hiddenField = document.createElement("input");
                hiddenField.setAttribute("type", "hidden");
                hiddenField.setAttribute("name", "data");
                hiddenField.setAttribute("value", dataJSON);
                form.appendChild(hiddenField);

                var hiddenFieldAuth = document.createElement("input");
                hiddenFieldAuth.setAttribute("type", "hidden");
                hiddenFieldAuth.setAttribute("name", "Authorization");
                hiddenFieldAuth.setAttribute("value", `Bearer ${window.keycloak?.token ? window.keycloak?.token : window.auth?.token}`);
                form.appendChild(hiddenFieldAuth);

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    };

    const confirmDelete = () => {
        if(canDeleteDocument){
            if (!dialogDeleteReason || dialogDeleteReason.length < 5) {
                setMessageTitle(t("Problem"));
                setMessage(t("You need to provide reason for deletion. Minimum 5 characters are required!"));
            } else {
                setCanDelete(false);
                dispatch(setProcessing(patientId));

                let promises = [];

                selectedThumbs.forEach((thumb) => {
                    if(thumb.__isStudy){
                        if(thumb.study === "") {
                            thumb.documents.forEach((doc) => {
                                promises.push(API.deleteDocument(doc.__id, dialogDeleteReason))
                            });
                        } else {
                            promises.push(API.deleteStudy(thumb.study, dialogDeleteReason))
                        }
                    } else {
                        promises.push(API.deleteDocument(thumb.__id, dialogDeleteReason))
                    }
                })

                Promise.all(promises).then((res)=> {
                    const counts = res.reduce(
                        (acc, item) => {
                            if (item.success) acc.ok++;
                            else acc.other++;
                            return acc;
                        },
                        { ok: 0, other: 0 }
                    );

                    if(counts.other > 0){
                        dispatch(setSnackbar({type: 'error', message: `Some documents cant be delete right now. Please try again later`}));
                    } else {
                        dispatch(setSnackbar({type: 'success', message: 'All documents deleted'}));
                    }
                    dispatch(loadDocumentsForPatientById(t, patientId, true));

                }).finally(()=>{
                    setSelectedThumbs([]);
                    setCanDelete(false);
                    dispatch(setProcessing(null));
                    dispatch(loadDocumentsForPatientById(t, patientObject.hospitalNumber, true));
                    setDialogDeleteReason("");
                });
            }
        }
    }

    const confirmDeleteOld = () => {
        if(canDeleteDocument) {
            if (!dialogDeleteReason || dialogDeleteReason.length < 5) {
                setMessageTitle(t("Problem"));
                setMessage(t("You need to provide reason for deletion. Minimum 5 characters are required!"));
            } else {
                setCanDelete(false);
                dispatch(setProcessing(patientId));
                if (!selectedThumbs[0].__isStudy) {
                    API.deleteDocument(selectedThumbs[0].__id, dialogDeleteReason).then(response => {
                        if (response.success) {
                            setMessageTitle(t("Information"));
                            setMessage(t("Document removed."));
                            dispatch(loadDocumentsForPatientById(t, patientObject.hospitalNumber, true));
                            setSelectedThumbs([]);
                            setDialogDeleteReason("");
                        } else {
                            setMessageTitle(t("Error while trying to delete document"));
                            setMessage(t("Document cant be delete right now. Please try again in a moment"));
                        }
                        setCanDelete(false);
                        dispatch(setProcessing(null));
                    }).catch(function (error) {
                        setMessageTitle(t("Error while trying to delete document"));
                        setMessage(t("Document cant be delete right now. Please try again in a moment"));
                        setCanDelete(false);
                        dispatch(setProcessing(null));

                        console.error("deleteDocument.error", error);
                    });
                } else {
                    if(selectedThumbs[0].study){
                        API.deleteStudy(selectedThumbs[0].study, dialogDeleteReason).then(response => {
                            if (response.success) {
                                setMessageTitle(t("Information"));
                                setMessage(t("Study removed."));
                                dispatch(loadDocumentsForPatientById(t, patientObject.hospitalNumber, true));
                                setSelectedThumbs([]);
                                setDialogDeleteReason("");
                            } else {
                                setMessageTitle(t("Error while trying to delete study!"));
                                setMessage(t("Study cant be delete right now. Please try again later"));
                            }
                            setCanDelete(false);
                            dispatch(setProcessing(null));
                        }).catch(function (error) {
                            setMessageTitle(t("Error while trying to delete study!"));
                            setMessage(t("Study cant be delete right now. Please try again later"));
                            setCanDelete(false);
                            dispatch(setProcessing(null));

                            console.error("deleteStudy.error", error);
                        });
                    } else {
                        let deletePromises = [];
                        _.forEach(selectedThumbs[0].documents, docToDeleteFromStudy => {
                            deletePromises.push(API.deleteDocument(docToDeleteFromStudy.__id, dialogDeleteReason))
                        });
                        Promise.all(deletePromises).then(responses => {
                            let totalSuccess = true;
                            _.forEach(responses, r => {
                                totalSuccess = totalSuccess && r.success;
                            })
                            if (totalSuccess) {
                                setMessageTitle(t("Information"));
                                setMessage(t("Study removed."));
                                dispatch(loadDocumentsForPatientById(t, patientObject.hospitalNumber, true));
                                setSelectedThumbs([]);
                                setDialogDeleteReason("");
                            } else {
                                setMessageTitle(t("Error while trying to delete documents in study!"));
                                setMessage(t("Documents cant be delete right now. Please try again later"));
                            }
                            setCanDelete(false);
                            dispatch(setProcessing(null));
                        }).catch(function (error) {
                            setMessageTitle(t("Error while trying to delete documents in study!"));
                            setMessage(t("Documents cant be delete right now. Please try again later"));
                            setCanDelete(false);
                            dispatch(setProcessing(null));

                            console.error("deleteStudy.error", error);
                        });
                    }

                }
            }
        }
    };

    const isDocumentOrStudySelected = document => {
        let isSelected = false;
        _.forEach(selectedThumbs, st => {
            if (!st.__isStudy && st.__id === document.__id) isSelected = true;
            if (st.__isStudy && st.groupId === document.groupId) isSelected = true;
        });
        return isSelected;
    };

    const removeDocumentOrStudyFromSelection = document => {
        let se = _.cloneDeep(selectedThumbs);
        _.remove(se, st => {
            if (!st.__isStudy && st.__id === document.__id) return true;
            if (st.__isStudy && st.groupId === document.groupId) return true;
        });
        return se;
    };
    useEffect(()=>{
        dispatch(setSelectedDocuments(selectedThumbs))
    },[selectedThumbs])

    const toggleSelected = document => () => {
        let se = _.cloneDeep(selectedThumbs);
        if (!isDocumentOrStudySelected(document)) {
            if(document.__isStudy){
                document.documents.forEach(doc => {
                    _.remove(se, st => {
                        if (!st.__isStudy && st.__id === doc.__id) return true;
                    });
                })
            }
            se.push(document);
        } else {
            se = removeDocumentOrStudyFromSelection(document);
        }
        if (se.length <= 4) {
            setSelectedThumbs(se);
        }
    };

    const renderDocuments = (documents) => {
        const renderedDocuments = [];
        const count = documents ? documents.length : 0;
        let position = 1;
        _.forEach(documents, document => {
            const imgSize = config.modules.thumbnail.size[thumbnailSize].loadWidth;
            //const imgSize = config.modules.thumbnail.size["big"].loadWidth;
            //let imgURL = `${config.apiUrl}/patients/${patientId}/documents/${document.__id}/pages/1/thumbnail/image?size=${imgSize}&Authorization=${window.keycloak ? window.keycloak.token : window.auth.token}`;
            let imgURL = `${config.apiUrl}/patients/${patientId}/documents/${document.__id}/pages/1/preview/lo/image?size=${imgSize}&Authorization=${window.keycloak ? window.keycloak.token : window.auth.token}`;

            if (document.__haveLoadError) {
                imgURL = "/image/error.png";
            }

            renderedDocuments.push(
                <Draggable draggableId={document.__id}  isDragDisabled={!canModifyDocument}
                           index={document.__position - 1} key={document.__id}>
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}

                            style={{
                                ...provided.draggableProps.style,
                                display: "inline-block",
                                // backgroundColor: snapshot.isDragging ? "lightgreen" : "",
                            }}
                        >
                            <Thumbnail
                                selectable
                                selected={isDocumentOrStudySelected(document)} onSelect={toggleSelected(document)}
                                document={document}
                                onOpenDocument={openDocument(document)}
                                position={{ current: document.__position, count }}
                                imageUrl={imgURL} size={thumbnailSize} />
                        </div>
                    )}
                </Draggable>
            );
            position++;
        });
        return renderedDocuments;
    };

    const countStudies = (studiesToRender, counter) => {
        _.forEach(studiesToRender, (study) => {
            if (study.__isGroup && isGroupFiltered(study)) {
                countStudies(study.data, counter);
            } else if (study.__isStudy && isFiltered(study)) {
                counter.currentCount++;
            }
        });
    };

    const onDragEnd = (result, study) => {
        if (!result.destination) {
            return;
        }

        if (result.destination.index === result.source.index) {
            return;
        }
        saveScrollPosition()

        //console.log(`Moving(${study.__key}) [${result.source.index}] -> [${result.destination.index}]`)

        dispatch(reorderStudyDocuments({
            study,
            sourceIndex: result.source.index,
            destinationIndex: result.destination.index,
            t
        }));

    }

    const filterCount = useRef(0)

    const renderStudies = (studiesToRender, studiesListRender, indexer, parent) => {
        _.forEach(studiesToRender, (study) => {
            if (study.__isGroup && isGroupFiltered(study)) {
                const innerStudiesRender = [];
                renderStudies(study.data, innerStudiesRender, indexer, study);
                if (!parent || parent.__expanded) {
                    let displayValue = study.__display || "No Date";
                    if (study.__unit === "month") {
                        displayValue = !study.__value ?? moment("2000-01-01").month(study.__value).format("MMMM")
                    }
                    if (study.__isGroup && study.data.length > 0 && study.data[0].__isGroup && !isStudiesListOpen) {
                        studiesListRender.push(<Button
                            onClick={() => {
                                dispatch(setExpanded({
                                    study, expand: !study.__expanded,
                                }));
                            }}
                            key={study.__key + ".7"}
                            className={clsx(classes.buttonSelector, classes.buttonSelectorGroups, study.__expanded && classes.buttonSelectorSelected)}
                            size="small" variant="contained">{displayValue}</Button>,
                        );
                    } else {
                        studiesListRender.push(<div
                            className={clsx(classes.groupTitle,
                                study.__parent && classes.groupWithParent)}
                            key={study.__key + ".1"}>{displayValue}</div>);
                    }
                }
                studiesListRender.push((
                    <div key={study.__key + ".2"}>{innerStudiesRender}</div>
                ));
            } else if (study.__isStudy && isFiltered(study)) {
                filterCount.current = filterCount.current + 1;
                // function SingleStudyList(props) {
                //     return (
                //         <PerfectScrollbar className="study-thumbs-inner-scroll-main" ref={el => scrollbarReferences.current[props.index] = el}>
                //             <div className={"study-thumbs-inner-scroll"} style={{ whiteSpace: "nowrap" }}>
                //                 <div className="study-thumbs-inner-docs">
                //                     {renderDocuments(props.study.documents)}
                //                 </div>
                //                 <div className="study-thumbs-inner-empty">
                //                 </div>
                //             </div>
                //         </PerfectScrollbar>
                //     );
                // }

                // function SingleStudyList(props) {
                //     return (
                //         <PerfectScrollbar className="study-thumbs-inner-scroll-main" ref={el => scrollbarReferences.current[props.index] = el}>
                //             {props.children}
                //         </PerfectScrollbar>
                //     );
                // }

                // if (!study.__rendered) {
                //     study.__rendered = <SingleStudyList index={indexer.index} study={study} />
                // }

                const indexerLocal = _.cloneDeep(indexer);

                studiesListRender.push(<div className={classes.studyElement} key={study.__key?study.__key:study.groupId + ".0"}>
                    <Paper className={classes.studyElementPaper}>

                        <div className={
                            clsx([classes.studyElementContentHeader, !study.__expanded && classes.studyElementContentHeaderCollapsed])
                        }
                             onClick={() => {
                                 dispatch(setExpanded({
                                     study, expand: !study.__expanded,
                                 }));
                             }}
                        >
                            {/* <div className={classes.colorCoded}
                                style={{
                                    backgroundColor: study.__colorString && study.__colorString.length === 1 ? study.__colorString[0] : config.defaultColorForMulti,
                                }}
                            /> */}

                            {!isStudiesListOpen &&
                            <div className={classes.colorCodedEx} onClick={e => {
                                e.preventDefault();
                                e.stopPropagation();
                                toggleSelected(study)();
                                // dispatch(setSelected({
                                //     study, select: !study.__selected,
                                // }));
                            }}>
                                {(!study.__selected && !isDocumentOrStudySelected(study)) &&
                                <UnselectedIcon
                                    className={classes.colorCodedSelectable}
                                    htmlColor={study.__colorString && study.__colorString.length === 1 ? study.__colorString[0] : config.defaultColorForMulti}/>
                                }
                                {(!!study.__selected || isDocumentOrStudySelected(study)) &&
                                <SelectedIcon
                                    className={classes.colorCodedSelectable}
                                    htmlColor={study.__colorString && study.__colorString.length === 1 ? study.__colorString[0] : config.defaultColorForMulti}/>
                                }
                                {/* <SelectedIcon htmlColor={"#ff0000"} /> */}
                            </div>
                            }

                            {isStudiesListOpen &&
                                <div onClick={(e)=>{
                                    openDocument(study.documents[0])()
                                }}>
                                <Grid container>
                                    <Grid item xs={2}>
                                        <div className={classes.colorCodedEx} onClick={e => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            toggleSelected(study)();
                                            // dispatch(setSelected({
                                            //     study, select: !study.__selected,
                                            // }));
                                        }}>
                                            { (!study.__selected && !isDocumentOrStudySelected(study)) &&
                                            <UnselectedIcon
                                                className={classes.colorCodedSelectable}
                                                htmlColor={study.__colorString && study.__colorString.length === 1 ? study.__colorString[0] : config.defaultColorForMulti} />
                                            }
                                            {(!!study.__selected || isDocumentOrStudySelected(study)) &&
                                            <SelectedIcon
                                                className={classes.colorCodedSelectable}
                                                htmlColor={study.__colorString && study.__colorString.length === 1 ? study.__colorString[0] : config.defaultColorForMulti} />
                                            }
                                            {/* <SelectedIcon htmlColor={"#ff0000"} /> */}
                                        </div>
                                        {formatDate(study.startDate)}
                                    </Grid>
                                    <Grid item xs={1} className={"study-table-data"}> {study.documents.length}</Grid>
                                    <Grid item xs={3} className={"study-table-data"}>{study.__typeString}</Grid>
                                    <Grid item xs={3} className={"study-table-data"}>{study.__location}</Grid>
                                    <Grid item xs={3} className={"study-table-data"}>{study.__operator} </Grid>
                                </Grid>
                            </div>
                            }
                            {!isStudiesListOpen &&
                            <div className={classes.studyElementContent}>
                                <Tooltip title={formatDate(study.startDate)}>
                                    <div className={clsx([classes.studyHeaderText, classes.studyHeaderDate])}>
                                        {formatDate(study.startDate)}
                                    </div>
                                </Tooltip>
                                <Tooltip title={study.__typeString}>
                                    <div className={clsx([classes.studyHeaderText, classes.studyHeaderStudy])}>
                                        {/*{t("Study")}: <strong>{study.__display}</strong>*/}
                                        {t("Type")}:  <strong>{study.__typeString}</strong>
                                    </div>
                                </Tooltip>
                                <Tooltip title={study.__location}>
                                    <div className={clsx([classes.studyHeaderText, classes.studyHeaderLocation])}>
                                        {t("Location")}:  <strong>{study.__location}</strong>
                                    </div>
                                </Tooltip>
                                <Tooltip title={study.__operator}>
                                    <div className={clsx([classes.studyHeaderText, classes.studyHeaderOperator])}>
                                        {t("Operator")}: <strong>{study.__operator}</strong>
                                    </div>
                                </Tooltip>
                            </div>
                            }

                            {!isStudiesListOpen && <div className={classes.expandedStatus}>
                                {study.__expanded && <KeyboardArrowUpIcon/>}
                                {!study.__expanded && <KeyboardArrowDownIcon/>}
                            </div>
                            }
                        </div>
                        {study.__expanded && !isStudiesListOpen && (
                            // <SingleStudyList index={indexer.index} >
                            //     <div className={"study-thumbs-inner-scroll"} style={{ whiteSpace: "nowrap" }}>
                            //         <div className="study-thumbs-inner-docs">
                            //             {renderDocuments(study.documents)}
                            //         </div>
                            //         <div className="study-thumbs-inner-empty">
                            //         </div>
                            //     </div>
                            // </SingleStudyList>
                            <DragDropContext onDragEnd={(result) => onDragEnd(result, study)}>
                                <Droppable droppableId={study.__key + ".droppable"} direction="horizontal">
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}>
                                            <div className="scroll-normal-white-x"
                                                 id={"study_list_"+study.__key}
                                                 ref={
                                                     el => {
                                                         scrollbarReferences.current[indexerLocal.index] = el
                                                     }}>
                                                <div className={"study-thumbs-inner-scroll"}
                                                     style={{
                                                         whiteSpace: "nowrap",
                                                         //   height: "calc(100% + 10px)",
                                                         // FIXME choose another color, eg. from Theme(dark/light)
                                                         backgroundColor: snapshot.isDraggingOver ? "lightblue" : "",
                                                     }}>
                                                    <div className="study-thumbs-inner-docs">
                                                        {renderDocuments(study.documents)}
                                                        {provided.placeholder && (
                                                            <div style={{ maxHeight: "1px", height: "1px" }}>
                                                                {provided.placeholder}
                                                            </div>)}
                                                    </div>
                                                    <div className="study-thumbs-inner-empty">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        )}
                    </Paper>
                </div>);

                indexer.index++;
            }
        });
    };


    // noinspection all
    const filterChanged = (filter) => (value) => {
        const filterCopy = _.cloneDeep(filters);
        _.forEach(filterCopy, singleFilter => {
            if (singleFilter._id === filter._id
                && (!singleFilter.subtype || singleFilter.subtype === filter.subtype)) {
                if (value === undefined || (value && value.length === 0)) {
                    delete singleFilter.__filterValue;
                } else {
                    if(moment.isMoment(value))
                        singleFilter.__filterValue = value.toISOString();
                    else {
                        if(!singleFilter.__filterValue)  singleFilter.__filterValue = [];
                        singleFilter.__filterValue.push(value);
                    }

                }
            }
        });

        let data = _.cloneDeep(patientCurrentPreferencesObject);
        data.filters = filterCopy;
        data.selectedFilterName = null;
        dispatch(setPatientCurrentPreference(data));
    };

    const removeItemFilter = (filterToRemove) => (value) => {

        const filterCopy = _.cloneDeep(filters);

        _.forEach(filterCopy, filter => {
            if (filter.name === filterToRemove.name) {
                if(value !== null && value === undefined){
                    delete filter.__filterValue
                } else {
                    if(filter.__filterValue.length > 1) {
                        try {
                            let indexToRemove = filter.__filterValue.findIndex((v) => v === value);
                            filter.__filterValue.splice(indexToRemove, 1);
                        } catch (ex) {
                            console.log(ex)
                        }
                    } else {
                        delete filter.__filterValue;
                    }
                }
                // if(value && filter.__filterValue.length > 1){
                //     let indexToRemove = filter.__filterValue.findIndex((v) => v === value);
                //
                //     filter.__filterValue.splice(indexToRemove, 1);
                // }
                // else
                //     delete filter.__filterValue
            }
        });


        let data = _.cloneDeep(patientCurrentPreferencesObject);
        data.filters = filterCopy;
        data.selectedFilterName = null;
        dispatch(setPatientCurrentPreference(data));
        setClearTrigger(!clearTrigger);

    };

    const handleSetFilterSet = (filterName) => {
        let data = _.cloneDeep(patientCurrentPreferencesObject);

        data.selectedFilterName = filterName;
        data.filters = config.modules.patient.filters;
        data.sortStudy = "date";

        if(filterName){
            let fil = _.find(patientCurrentPreferencesObject?.filtersList, {name: filterName});
            if(fil) {
                data.filters = fil.filters;
                data.sortStudy = fil.sortStudy;
            }
        }

        dispatch(setPatientCurrentPreference(data));
    }

    const isGroupFiltered = (what) => {
        let filtered = false;
        _.forEach(what.data, (study) => {
            if (!filtered) {
                if (study.__isGroup)
                    filtered = isGroupFiltered(study);
                else
                    filtered = isFiltered(study);
            }
        });
        return filtered;
    };

    const getTextForNull = (type) => {
        let value;
        // eslint-disable-next-line default-case
        switch (type) {
            case "Location":
                value = t("Location not set");
                break;
            case "Operator":
                value = t("Operator not set");
                break;
            case "Type":
                value = t("NO TYPE");
                break;
        }
        return value;
    };

    const listColumnsStatusInit = {
        image: {
            field: "documents"
        },
        date: {
            field: "startDate",
            filterActive: false,
            filter: null,
        },
        type: {
            field: "__typeString",
            filterActive: false,
            filter: null,
        },
        location: {
            field: "__location",
            filterActive: false,
            filter: "",
        },
        operator: {
            filterActive: false,
            field: "__operator",
            filter: null,
        }
    }

    const [listColumnsStatus, setListColumnsStatus] = useState(listColumnsStatusInit)
    const [filterListTypeContain, setFilterListTypeContain] = useState(true)

    const checkFilterValue = (value, filter) => {
        if (!filterListTypeContain) return _.toLower(value) === _.toLower(filter);
        else return _.toLower(value).includes(_.toLower(filter));
    };

    const isFiltered = (what) => {

        let filtered = true;
        _.forEach(filters, filter => {
            if (filtered) {
                if (filter.type === "string") {
                    let values = _.get(what, filter.key)?.split(", ") || "";

                    if (filter.__filterValue === null)
                        filtered = _.indexOf(values, getTextForNull(filter.name)) > -1;
                    else if (filter.__filterValue) {
                        filtered = false;
                        values.forEach((value)=> {
                            if(filter.__filterValue.includes(value)) {
                                filtered = true;
                            }
                        });
                    }
                    // filtered = _.indexOf(values, filter.__filterValue) > -1;

                } else if (filter.type === "date") {
                    if (filter.__filterValue) {
                        const valToCheck = moment(_.get(what, filter._id));
                        filtered = filter.subtype === "from" ?
                            valToCheck.isSameOrAfter(filter.__filterValue) : valToCheck.isSameOrBefore(filter.__filterValue);
                    }
                }
            }
        });


        if(isStudiesListOpen) {
            if(listColumnsStatus.location.filterActive && !checkFilterValue(_.get(what, "__location"),listColumnsStatus.location.filter)){
                filtered = false
            }
            if(listColumnsStatus.type.filterActive && !checkFilterValue(_.get(what, "__typeString"),listColumnsStatus.type.filter)){
                filtered = false
            }
            if(listColumnsStatus.operator.filterActive && !checkFilterValue(_.get(what, "__operator"),listColumnsStatus.operator.filter)){
                filtered = false
            }
        }

        return filtered;
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (type, that) => {
        setAnchorEl(null);
        let data = _.cloneDeep(patientCurrentPreferencesObject);
        data.sortStudy = type;
        data.selectedFilterName = null;
        dispatch(setPatientCurrentPreference(data));
        //  dispatch(regroupStudies(type));
    };

    // const studiesListRender = useMemo(() => {
    //     const studiesListRender = [];
    //     if (studiesObject) {
    //         renderStudies(studiesObject, studiesListRender, {
    //             index: 0,
    //         });
    //     }
    //     return studiesListRender;
    // }, [studiesObject]);



    // const groupMap = {
    //     location: "__location",
    //     operator: "__operator",
    //     type: "__typeString",
    //     date: "startDate"
    // };

    // useEffect(()=>{
    //     setSorts((sorts)=> {
    //         let sortsTmp = [...sorts]
    //         sortsTmp[0] =  {
    //             id: studiesGroupObject,
    //             field: groupMap[studiesGroupObject],
    //             direction: (!studiesGroupObject || studiesGroupObject === "date")? "desc": "asc"
    //         }
    //         return sortsTmp
    //     })
    // },[studiesGroupObject])

    const [sorts, setSorts] = useState([]);

    const clearFiltersAndSorts = () => {
        setSorts([]);
        setListColumnsStatus(listColumnsStatusInit)
    }

    const filtersListAreSet = () => {
        return sorts.length > 0 || listColumnsStatus.location.filterActive || listColumnsStatus.type.filterActive || listColumnsStatus.operator.filterActive
    }

    const filtersListAreActive = () => {
        return listColumnsStatus.location.filterActive || listColumnsStatus.type.filterActive || listColumnsStatus.operator.filterActive
    }

    filterCount.current = 0;

    if (studiesObject && studiesListRender.length === 0) {
        let clone = _.cloneDeep(studiesUngroupedObject);

        _.forEach(sorts, order => {
            clone = _.orderBy(clone, (row) => {
                if(order.field === "documents") return _.get(row, order.field).length;
                return _.get(row, order.field);
            }, [order.direction]);
        });
        renderStudies(isStudiesListOpen? clone: studiesObject, studiesListRender, {
            index: 0,
        });
    }

    useEffect(() => {
        if (studiesObject) {
            renderStudies(studiesObject, studiesListRender, {
                index: 0,
            });

            const v = {
                currentCount: 0,
            };
            countStudies(studiesObject, v);
            scrollbarReferences.current = scrollbarReferences.current.slice(0, v.currentCount);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [studiesObject]);

    const openStudies = (studiesToRender, counter) => {
        _.forEach(studiesToRender, (study) => {
            if (study.__isGroup && isGroupFiltered(study)) {
                openStudies(study.data, counter);
            } else {
                if (counter.currentCount < patientPreferencesObject.initiallyOpen && study.__isStudy && isFiltered(study)) {
                    if(!study.__expanded)
                        dispatch(setExpanded({
                            study, expand: true,
                        }));
                    counter.currentCount++;
                } else {
                    /* want close?
                    if(study.__expanded)
                         dispatch(setExpanded({
                             study, expand: false,
                         }))*/
                }
            }
        });
    };

    useEffect(() => {
        if (studiesObject) {
            openStudies(studiesObject, {currentCount: 0});
        }
    }, [filters, studiesGroupObject, patientPreferencesObject]);

    const [clearTrigger, setClearTrigger] = React.useState(true);

    useEffect(() => {
        if(patientPreferencesObject?.filtersList?.length && !patientCurrentPreferencesObject?.filters && !props.patientIdOpenFromAdmin) {
            let data = _.cloneDeep(patientPreferencesObject);

            let filterSet = _.find(data.filtersList, {name: data.selectedFilterName});
            data.filters = filterSet?.filters;
            data.sortStudy = filterSet?.sortStudy;
            dispatch(setPatientCurrentPreference(data));
        }

    },[patientPreferencesObject])

    useEffect(() => {
        if(!props.patientIdOpenFromAdmin) {
            if(!patientCurrentPreferencesObject) {
                dispatch(cloneCurrentPref());
            } else {
                if(patientCurrentPreferencesObject?.thumbnailSize !== thumbnailSize) {
                    setThumbnailSize(patientCurrentPreferencesObject.thumbnailSize);
                }
                if(patientCurrentPreferencesObject) {
                    setFiltersAndSort(patientCurrentPreferencesObject);
                }
            }
        }

    }, [clearTrigger, patientCurrentPreferencesObject, documentsObject]);


    const setFiltersAndSort = (fil) => {
        const filterCopy = _.cloneDeep(config.modules.patient.filters);
        let newFilters = fil.filters;
        let newSort = "date";

        if(fil.filters === null && fil.selectedFilterName) {
            let findFilter = fil.filtersList.find((f) => f.name === fil.selectedFilterName);
            newFilters = findFilter.filters
            dispatch(regroupStudies(findFilter.sortStudy));
        } else if (studiesGroupObject && fil.sortStudy && fil.sortStudy !== studiesGroupObject) {
            dispatch(regroupStudies(fil.sortStudy));
        }

        if (newFilters !== filters) {
            _.forEach(newFilters, filter => {
                _.forEach(filterCopy, singleFilter => {
                    if (singleFilter._id === filter._id
                        && (!singleFilter.subtype || singleFilter.subtype === filter.subtype)) {

                        if (filter.__filterValue !== undefined)
                            singleFilter.__filterValue = moment.isMoment(filter.__filterValue) ? filter.__filterValue.toISOString() : filter.__filterValue;
                        else
                            delete singleFilter.__filterValue;
                    }
                });
            });
        }
        setFilters(filterCopy);
    }

    const handleSaveFilters = () => {
        let data = _.cloneDeep(patientPreferencesObject);

        // data.filters = patientCurrentPreferencesObject.filters;
        // data.sortStudy = patientCurrentPreferencesObject.sortStudy;

        if(data.selectedFilterName === null) data.selectedFilterName = newFilterName;

        data.filtersList.push({
            name: newFilterName,
            filters: patientCurrentPreferencesObject?.filters,
            sortStudy: patientCurrentPreferencesObject?.sortStudy
        });

        dispatch(savePref(data));

        closeModal();
    };

    useEffect(() => {
        if(newFilterName && newFilterName !== "") {
            let data = _.cloneDeep(patientCurrentPreferencesObject);
            data.selectedFilterName = newFilterName;
            dispatch(setPatientCurrentPreference(data));

            setNewFilterName("");
        }

    },[patientCurrentPreferencesObject]);

    const filtersAreSet = () => {
        let areSet = false;
        _.forEach(filters, filter => {
            if (filter.__filterValue) {
                areSet = true;
            }
        });
        return areSet;
    };


    const handleSizeChange = () => {

        let data = _.cloneDeep(patientCurrentPreferencesObject);
        data.thumbnailSize = patientCurrentPreferencesObject?.thumbnailSize === "big" ? "small" : "big";
        dispatch(setPatientCurrentPreference(data));


        setTimeout(() => {
            window._scrollBarRef.updateScroll();
            _.forEach(scrollbarReferences.current, (v, i) => {
                if (v) {
                    v.updateScroll();
                }
            });
        }, 100)
    };


    // useEffect(()=>{
    //     if(userObject.permissions) {
    //         setUserIsAdmin(dispatch(isAdmin()));
    //         setUserCanUpload(dispatch(canUpload()));
    //         setUserCanDownload(dispatch(canDownloadDoc()));
    //     }
    //     return () => {}
    // },[userObject, documentsObject])


    const removeFilter = (filterToRemove, indexToRemove) => {

        const filterCopy = _.cloneDeep(filters);

        _.forEach(filterCopy, filter => {
            if (filter.name === filterToRemove.name) {
                if(indexToRemove !== undefined && filter.__filterValue.length > 1)
                    filter.__filterValue.splice(indexToRemove, 1);
                else
                    delete filter.__filterValue
            }
        });


        let data = _.cloneDeep(patientCurrentPreferencesObject);
        data.filters = filterCopy;
        data.selectedFilterName = null;
        dispatch(setPatientCurrentPreference(data));
        setClearTrigger(!clearTrigger);
    }

    const [isModalOpen, openModal, closeModal] = useOpenState(false, true);
    const [isFilterModalOpen, openFilterModal, closeFilterModal] = useOpenState(false, true);
    const [newFilterName, setNewFilterName] = useState("")
    const topBarRef = React.useRef(null);

    useEffect(()=>{
        if(document.getElementById("studiesListContainer")) {
            if(props.patientIdOpenFromAdmin) {
                document.getElementById("studiesListContainer").style.height = `calc(100%)`;
            } else if(topBarRef.current){
                document.getElementById("studiesListContainer").style.height = `calc(100% - ${topBarRef.current?.clientHeight}px)`
            }
        }

    },[topBarRef.current?.clientHeight, filters, isStudiesListOpen, props.patientIdOpenFromAdmin, loadingDocumentObject, loadingPatientObject])


    const saveFinalDoc = async () => {
        let selectedDocument = selectedThumbs[0];

        let docsData = await API.getDocumentsForPatientByID(patientId);

        let documents = docsData.__data;

        const dataByDocumentId = {
            items: [],
        };

        let annotationFinal = {
            user: Formatter.formatUserFullName(userObject),
            userName: userObject.userName,
            date: moment()
        };

        dataByDocumentId.items.push({
            docId: selectedDocument.__id,
            path: "annotationFinal",
            metadata: annotationFinal,
        });

        if (selectedDocument.metadata?.originalDoc?.externalId) {

            let originalDocId = selectedDocument.metadata.originalDoc.externalId;
            let originalDocPage = selectedDocument.metadata.originalDoc.page;


            documents?.forEach((doc) => {

                if (!doc.metadata.annotationFinal && originalDocId) {

                    if ((originalDocId === doc.metadata.originalDoc?.externalId && originalDocPage === doc.metadata.originalDoc?.page) || originalDocId === doc.externalId) {
                        dataByDocumentId.items.push({
                            docId: doc.__id,
                            path: "isOldCopy",
                            metadata: true,
                        });
                    }

                    if (originalDocId === doc.externalId) {
                        let finalPages = doc.metadata.finalPages ? [...doc.metadata.finalPages.finalPages] : [];
                        finalPages.push(selectedDocument.metadata.originalDoc.page);

                        let finalPagesData = doc.metadata.finalPages ? [...doc.metadata.finalPages.finalPagesData] : [];
                        finalPagesData.push({
                            page: selectedDocument.metadata.originalDoc.page,
                            ...annotationFinal
                        });

                        dataByDocumentId.items.push({
                            docId: doc.__id,
                            path: "finalPages",
                            metadata: {
                                finalPages: finalPages,
                                finalPagesData: finalPagesData
                            },
                        });
                    }
                }
            })
        }

        API.updateDocumentsData(dataByDocumentId).then(data => {
            console.log("updateDocumentsData.response.data", data);
            dispatch(setSnackbar({type: 'success', message: 'Document marked as finish'}));

        }).catch(function (error) {

            console.error("updateDocumentsData.error", error);
            dispatch(setSnackbar({type: 'error', message: "Document dont marked as finish"}));

        }).finally(()=>{
            closeConfirmSaveFinal();
            setSelectedThumbs([]);
            dispatch(loadDocumentsForPatientById(t, patientId, true));
        });

    }

    const saveUnFinalDoc = async () => {
        let selectedDocument = selectedThumbs[0];

        let docsData = await API.getDocumentsForPatientByID(patientId);

        let documents = docsData.__data;

        const dataByDocumentId = {
            items: [],
        };

        dataByDocumentId.items.push({
            docId: selectedDocument.__id,
            path: "annotationFinal",
            metadata: null,
        });

        if (selectedDocument.metadata?.originalDoc?.externalId) {

            let originalDocId = selectedDocument.metadata.originalDoc.externalId;
            let originalDocPage = selectedDocument.metadata.originalDoc.page;


            documents?.forEach((doc) => {

                if (originalDocId) {
                    if (originalDocId === doc.metadata.originalDoc?.externalId && originalDocPage === doc.metadata.originalDoc?.page){
                        dataByDocumentId.items.push({
                            docId: doc.__id,
                            path: "isOldCopy",
                            metadata: false,
                        });
                    }

                    if (originalDocId === doc.externalId) {
                        let finalPages = doc.metadata.finalPages ? [...doc.metadata.finalPages.finalPages] : [];
                        let indexToDelete = finalPages.findIndex((page) => page === originalDocPage)
                        finalPages.splice(indexToDelete, 1)

                        let finalPagesData = doc.metadata.finalPages ? [...doc.metadata.finalPages.finalPagesData] : [];
                        finalPagesData.splice(indexToDelete, 1)

                        if(finalPages.length === 0) {
                            dataByDocumentId.items.push({
                                docId: doc.__id,
                                path: "isOldCopy",
                                metadata: false,
                            });
                        }

                        dataByDocumentId.items.push({
                            docId: doc.__id,
                            path: "finalPages",
                            metadata: {
                                finalPages: finalPages,
                                finalPagesData: finalPagesData
                            },
                        });
                    }
                }
            })
        }


        API.updateDocumentsData(dataByDocumentId).then(data => {
            console.log("updateDocumentsData.response.data", data);
            dispatch(setSnackbar({type: 'success', message: 'Document marked as unfinished'}));

        }).catch(function (error) {

            console.error("updateDocumentsData.error", error);
            dispatch(setSnackbar({type: 'error', message: "Document dont marked as unfinished"}));

        }).finally(()=>{
            setSelectedThumbs([]);
            closeConfirmSaveUnfinal();
            dispatch(loadDocumentsForPatientById(t, patientId, true));
        });

    }

    const renderCustomOption = (opt, index) => {
        return <MenuItem key={opt?.name} value={opt?.name}>{t(opt?.name)}</MenuItem>
    }

    useEffect(()=>{

        const handleOnWheelEvent = (e) => {
            const elements = document.elementsFromPoint(e.pageX, e.pageY);
            const firstFilterContainer = Array.from(elements).filter(el => el.id.startsWith("study_list"));

            if(firstFilterContainer.length > 0) {
                let isEnd = firstFilterContainer[0].scrollLeft + firstFilterContainer[0].offsetWidth >= firstFilterContainer[0].scrollWidth;
                let isStart = firstFilterContainer[0].scrollLeft === 0;

                if((!isEnd && e.deltaY >= 0) || (!isStart && e.deltaY < 0)){

                    firstFilterContainer[0].scrollLeft += (e.deltaY < 0? -100 : 100);

                    e.stopPropagation();
                    e.preventDefault();
                }
            }
        }

        window.addEventListener("wheel", handleOnWheelEvent,{ passive: false })

        return () => {
            window.removeEventListener("wheel", handleOnWheelEvent,{ passive: false })
        }

    },[]);

    const rendererFunction = (filter) => {
        switch(filter._id){
            case "metadata.operatorName": return operatorOptionRenderer;
            default: return null
        }
    }

    const operatorOptionRenderer = (item) => {
        const itemAnalyzed = analiseStringOptionData(item);
        if (itemAnalyzed[0] == null) {
            return (<div><span className={classes.emptyMark}>{getTextForNull("Operator")}</span></div>);
        } else {
            let renderItem = [];
            if (itemAnalyzed[1] > 0) {
                for (let i = 1; i <= itemAnalyzed[1]; i++) {
                    renderItem.push(<span className={classes.spaceMark}>SPACE</span>);
                }
            }
            if (itemAnalyzed[0] == "<empty>") {
                return (<span className={classes.emptyMark}>{itemAnalyzed[0]}</span>);
            } else {
                renderItem.push((<span className={classes.noCapitalize}>{itemAnalyzed[0]}</span>));
            }
            if (itemAnalyzed[2] > 0) {
                for (let i = 1; i <= itemAnalyzed[2]; i++) {
                    renderItem.push(<span className={classes.spaceMark}>SPACE</span>);
                }
            }
            return (<div>{renderItem}</div>);
        }
        return item;
    }

    const handleSortAction = (id, field) => {
        let item = {
            id: id,
            field: field,
            direction: "asc"
        }
        let itemIndex = sorts.findIndex((s) => s.id === id);

        if(itemIndex > -1) {
            if(sorts[itemIndex].direction === "desc") {
                setSorts((sorts) => {
                    let sortsTmp = [...sorts]
                    sortsTmp.splice(itemIndex,1)
                    return sortsTmp
                })
            } else {
                setSorts((s) => {
                    let sortsTmp = _.cloneDeep(s);
                    sortsTmp[itemIndex].direction = "desc";
                    return sortsTmp
                })
            }
        } else {
            setSorts((sorts) => {
                let sortsTmp = [...sorts]
                sortsTmp.unshift(item)
                return sortsTmp
            })
        }
    }



    const renderListHeaderItem = (type, label, onlySort = false) => {
        return  <div className={clsx("headerLabel", sorts.find(s => s.id === type) && "active",
            listColumnsStatus[type].filterActive && "filterActive")} >
            <>
                <div className={"headerSort"} onClick={(e)=>{
                    handleSortAction(type, listColumnsStatus[type].field)
                }}>
                    <div style={{color: sorts.find(s => s.id === type)? listColumnsStatus[type].filterActive? "white": "black": "grey", display: "flex", alignItems: "center"}}>
                        {sorts.find(s => s.id === type)?.direction === "desc" ? <ArrowUpwardIcon/>:  <ArrowDownwardIcon/>}
                    </div>

                </div>
                <div className={"headerName"}>
                    <input
                        placeholder={label}
                        value={listColumnsStatus[type].filter}
                        onChange={(e)=>{
                            setListColumnsStatus((s)=>{
                                return {
                                    ...s,
                                    [type]: {
                                        ...s[type],
                                        filter: e.target.value
                                    }
                                }
                            })}}
                    />
                    {!listColumnsStatus[type].filterActive && <div className={clsx("name", onlySort && "no-sort")}> {label} </div>}
                </div>
                {!onlySort && <div className={"headerFind"}
                                   onClick={()=>{
                                       setListColumnsStatus((s)=> {
                                           return {
                                               ...s,
                                               [type]: {
                                                   ...s[type],
                                                   filter: "",
                                                   filterActive: !s[type].filterActive
                                               }
                                           }
                                       })
                                   }}
                >
                    {listColumnsStatus[type].filterActive?  <CloseIcon/>: <SearchIcon/>}
                </div>
                }
            </>
        </div>
    }

    const studiesListInitData = useSelector(globalVariable("StudiesList"));

    useEffect(()=>{
        dispatch(setGlobalVariable({
            name: "StudiesList",
            value: {
                patientId: patientObject.hospitalNumber,
                isStudiesListOpen: isStudiesListOpen,
                sorts: sorts,
                listColumnsStatus: listColumnsStatus,
                filterListTypeContain: filterListTypeContain
            },
        }));
    },[sorts, listColumnsStatus, isStudiesListOpen])

    useEffect(()=>{
        if(studiesListInitData && studiesListInitData.isStudiesListOpen && studiesListInitData.patientId === patientObject.hospitalNumber) {
            openStudiesList();
            setSorts(studiesListInitData.sorts);
            setListColumnsStatus(studiesListInitData.listColumnsStatus);
            setFilterListTypeContain(studiesListInitData.filterListTypeContain)
        }
    },[]);

    return (
        <div style={{ height: "calc(100% - 10px)" }}>

            <ThumbnailPrev/>

            <AgyleDialog
                title={t(`Studies List`)}
                open={false}
                onClose={closeStudiesList}
                width={"lg"}
                fullWidth
                onSave={closeStudiesList}
                disableSave
            >
                <StudiesList/>
            </AgyleDialog>

            <MessageBox
                onClose={()=>closeConfirmSaveFinal()}
                title={t("Confirmation")}
                haveAccept={{yes: t("Submit"), no: t("Close")}}
                onAccept={saveFinalDoc}
                message={t("Are you sure you want to final?")}
                open={isConfirmSaveFinalOpen}
                warning
            />

            <MessageBox
                onClose={()=>closeConfirmSaveUnfinal()}
                title={t("Confirmation")}
                haveAccept={{yes: t("Submit"), no: t("Close")}}
                onAccept={saveUnFinalDoc}
                message={t("Are you sure you want to unset final copy?")}
                open={isConfirmSaveUnfinalOpen}
                warning
            />

            <MessageBox
                onClose={()=>closeConfirmHoldingPenBack()}
                title={t("Confirmation")}
                haveAccept={{yes: t("Submit"), no: t("Close")}}
                onAccept={handleBackToHoldingPen}
                message={t("Are you sure you want to back document to Holding Pen?")}
                open={isConfirmHoldingPenBackOpen}
                warning
            />


            <MessageBox onClose={() => {
                setMessage(null);
                setMessageTitle(t("Information"));
            }} title={messageTitle} message={message} open={!!message} />

            {/* <MessageBox
                onClose={() => {
                    setCanDelete(false);
                }}
                title={t("Confirmation")}
                haveAccept={{ yes: t("Accept"), no: t("Cancel") }}
                onAccept={confirmDelete}
                message={t("Are you sure you want to remove this document?")}
                open={!!canDelete} /> */}

            <Dialog fullWidth={true} maxWidth="md" onClose={() => setCanDelete(false)} open={!!canDelete}>
                <DialogTitle>{t("Remove confirm")}</DialogTitle>
                <DialogContent>
                    <div>
                        <div style={{ marginBottom: 10 }}>
                            {/* {dialogMessage} */}
                            {t("Ary sure you want to delete this document? Please specify the reason for removing document and click confirm!")}
                        </div>
                        <div>
                            <TextareaAutosize
                                className={classes.reasonText}
                                onChange={e => setDialogDeleteReason(e.target.value)}
                                value={dialogDeleteReason}
                                minRows={5} placeholder={t("enter deletion reason")} />
                        </div>
                    </div>
                </DialogContent>
                <DialogContent>
                    <div>
                        <Button autoFocus onClick={confirmDelete} color="primary">
                            {t("Confirm")}
                        </Button>
                        <Button autoFocus onClick={() => setCanDelete(false)} color="primary">
                            {t("Cancel")}
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>

            <AgyleDialog
                contentStyle={classes.dialogContentStyle}
                title={"Study filters"}
                onClose={closeFilterModal}
                fullWidth
                width={"md"}
                titleStyle={classes.titleStyleDialog}
                disableActions
                closeButtonOnHeader
                open={isFilterModalOpen}>

                <div>
                    <Grid container alignItems={"flex-start"} spacing={2} style={{marginBottom: 40}}>
                        <Grid item xs={2}>
                            <div className={classes.filterNameInModal}> Sort by </div>
                        </Grid>
                        <Grid item xs={10}>
                            <div style={{display: "inline-flex", gap: 15}}>
                                <div className={clsx(classes.menuItemChip,  studiesGroupObject === "date" && "selected")}
                                     onClick={handleSelect.bind(this, "date")}>Date</div>
                                <div className={clsx(classes.menuItemChip,  studiesGroupObject === "type" && "selected")}
                                     onClick={handleSelect.bind(this, "type")}>Type</div>
                                <div className={clsx(classes.menuItemChip,  studiesGroupObject === "location" && "selected")}
                                     onClick={handleSelect.bind(this, "location")}>Location</div>
                                <div className={clsx(classes.menuItemChip,  studiesGroupObject === "operator" && "selected")}
                                     onClick={handleSelect.bind(this, "operator")}>Operator</div>
                            </div>

                        </Grid>
                        {filters.map((filter) => {
                            return <Grid item xs={filter.type === "date"? 6 : 4} key={'filter-grid-'+filter.name}>
                                <EyonixFilterAddButton
                                    fullView
                                    onChange={filterChanged(filter)}
                                    onRemove={removeItemFilter(filter)}
                                    config={{
                                        name: t(filter.name),
                                        filter: filter,
                                    }}
                                    filtersValues={filter.__filterValue}
                                    data={documentsObject ? documentsObject.__data : []}
                                    field={filter._id}
                                    render={rendererFunction(filter)}
                                    key={'filter-add-button-'+filter._id}/>
                            </Grid>
                        })}

                    </Grid>
                    <div className={classes.modalBottomButtons}>
                        <div className={clsx(classes.menuItemChip)}
                             onClick={openModal}>
                            Save filter
                        </div>
                        <div className={clsx(classes.clearButton)}
                             onClick={()=>{handleSetFilterSet("")}}>
                            Clear All
                        </div>
                    </div>
                </div>
            </AgyleDialog>
            <Dialog open={isModalOpen} onClose={closeModal}>
                <DialogTitle>New Filter</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        value={newFilterName}
                        onChange={(evt) => { setNewFilterName(evt.target.value) }}
                        label="Filter Name"
                        fullWidth
                        variant="standard"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeModal}>Cancel</Button>
                    <Button disabled={newFilterName.length < 3 || patientPreferencesObject.filtersList.some((f)=> f.name === newFilterName) } onClick={handleSaveFilters}>Save</Button>
                </DialogActions>
            </Dialog>


            {!props.patientIdOpenFromAdmin &&
            <div ref={topBarRef} style={{margin: "10px 20px 0 20px"}}>
                {patientObject && <Grid container alignItems={"flex-start"} spacing={0}>

                    <Grid item xs={3} style={{display: "flex", alignItems: "center", gap: 10}}>
                        <AgyleSelectField
                            label={t("Selected filter")}
                            style={{
                                height: '100%',
                                minHeight: '36px'
                            }}
                            onChange={(value) => {
                                handleSetFilterSet(value)
                            }}
                            withBackground
                            withBorder
                            defaultClearValue={""}
                            customObject={renderCustomOption}
                            options={patientCurrentPreferencesObject?.filtersList}
                            value={patientCurrentPreferencesObject?.selectedFilterName}
                        />

                        <IconButton size="small"
                                    onClick={openFilterModal}
                                    style={{minWidth: "0"}}>
                            <FilterIcon3 />
                        </IconButton>

                        {!patientCurrentPreferencesObject?.selectedFilterName && (
                            studiesGroupObject !== "date" || filters.some((f) => f.__filterValue)
                        ) && <div style={{display: "inline-block"}}>
                            <IconButton size="small"
                                        onClick={openModal}
                                        style={{minWidth: "0"}}>
                                <SaveIcon2 className={classes.removeIcon}/>
                            </IconButton>
                        </div>}
                    </Grid>
                    <Grid item xs>
                        <div style={{display: "flex", alignItems: "flex-start", justifyContent: "flex-end", gap: 10}}>
                            <div className={clsx(classes.filterItem, classes.filtersBlockGroup)}>
                                {!isStudiesListOpen &&
                                <Tooltip title="Grouped by:" placement="top">
                                    <div className={classes.groupedButton}
                                         style={{color: isStudiesListOpen? "grey": "white", borderColor: isStudiesListOpen? "grey": "white"}}
                                         onClick={handleClick}>
                                            <span>
                                                Group: {studiesGroupObject ? studiesGroupObject : "date"}
                                            </span>
                                    </div>
                                </Tooltip>
                                }
                                <Menu
                                    id="simple-menu"
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={handleClose}
                                    placement="bottom-end"
                                >
                                    <MenuItem className={classes.menuItem}
                                              onClick={handleSelect.bind(this, "date")}>DATE</MenuItem>
                                    <MenuItem className={classes.menuItem}
                                              onClick={handleSelect.bind(this, "type")}>TYPE</MenuItem>
                                    <MenuItem className={classes.menuItem}
                                              onClick={handleSelect.bind(this, "location")}>LOCATION</MenuItem>
                                    <MenuItem className={classes.menuItem}
                                              onClick={handleSelect.bind(this, "operator")}>OPERATOR</MenuItem>
                                </Menu>
                            </div>
                            {filters.map((filter, idx) => {
                                let renderedChips = [];

                                renderedChips.push(<EyonixFilterAddButton
                                    onChange={filterChanged(filter)}
                                    onRemove={removeItemFilter(filter)}
                                    config={{
                                        name: t(filter.name),
                                        filter: filter,
                                    }}
                                    filtersValues={filter.__filterValue}
                                    data={documentsObject ? documentsObject.__data : []}
                                    field={filter._id}
                                    dontCloseOnChoose={true}
                                    render={rendererFunction(filter)}
                                    key={'filter-btn-'+filter._id+"-"+idx}/>)

                                return <div key={'filter-chips-'+filter._id+"-"+idx}> {renderedChips} </div>
                            })}
                        </div>

                    </Grid>
                </Grid>
                }
                {patientObject &&
                <div style={{marginTop: 10}}>
                    <Grid container alignItems={"center"} justifyContent={"space-between"} spacing={0}>

                        <Grid item xs={9}>
                            {selectedThumbs.length === 0 && !loadingDocumentObject &&
                            <div className={classes.selectedToolbox}>
                                <div className={classes.selectedToolboxText}>
                                    {t("Showing")}&nbsp;&nbsp;&nbsp;{filterCount.current} / {studiesUngroupedObject?.length}
                                    &nbsp;&nbsp;&nbsp;
                                </div>
                            </div>
                            }
                            <div>
                                {selectedThumbs && selectedThumbs.length > 0 &&
                                <div className={classes.selectedToolbox}>
                                    <Tooltip title={t("Clear selection")} placement="top" enterDelay={1000}>
                                        <IconButton style={{marginLeft: -12}} onClick={() => setSelectedThumbs([])} size="large">
                                            <CloseIcon className={classes.smallerIcon} />
                                        </IconButton>
                                    </Tooltip>
                                    <div className={classes.selectedToolboxText}>
                                        {t("Selected")}&nbsp;&nbsp;&nbsp;{selectedThumbs.length} / 4&nbsp;&nbsp;&nbsp;
                                    </div>
                                    {selectedThumbs.length > 1 &&
                                    <Tooltip title={t("Compare")} placement="top" enterDelay={1000}>
                                        <IconButton onClick={openGroupForCompare} size="large">
                                            <CompareIcon className={classes.smallerIcon} />
                                        </IconButton>
                                    </Tooltip>
                                    }
                                    {canDeleteDocument &&
                                    <Tooltip title={t("Delete")} placement="top" enterDelay={1000}>
                                        <IconButton onClick={deleteSelectedDocuments} size="large">
                                            <BinIcon className={classes.smallerIcon} />
                                        </IconButton>
                                    </Tooltip>
                                    }

                                    {selectedThumbs.length !== 0 && canPrintAndDownloadDocument &&
                                    <Tooltip title={t("Download")} placement="top" enterDelay={1000}>
                                        <IconButton
                                            ref={anchorRefDownload}
                                            onClick={handleToggle}
                                            size="large">
                                            <DownloadIcon className={classes.smallerIcon}/>
                                        </IconButton>
                                    </Tooltip>
                                    }
                                    {canBackDocumentToHolding &&
                                    <Tooltip title={t("Back document to Holding Pen")} placement="top" enterDelay={1000}>
                                        <IconButton
                                            onClick={openConfirmHoldingPenBack}
                                            size="large">
                                            <AirlineStopsIcon className={classes.smallerIcon}/>
                                        </IconButton>
                                    </Tooltip>
                                    }
                                    {(selectedThumbs.length === 1 && !selectedThumbs[0].__isStudy) &&
                                    !selectedThumbs[0].metadata.isOldCopy &&
                                    !selectedThumbs[0].metadata.annotationFinal &&
                                    selectedThumbs[0].metadata.saved && canModifyDocument &&
                                    <Tooltip title={t("Set as final document")} placement="top" enterDelay={1000}>
                                        <IconButton onClick={()=>openConfirmSaveFinal()} size="large">
                                            <FinalAnnotationIcon className={classes.smallerIcon} />
                                        </IconButton>
                                    </Tooltip>
                                    }

                                    {(selectedThumbs.length === 1 && !selectedThumbs[0].__isStudy) &&
                                    selectedThumbs[0].metadata.annotationFinal &&
                                    selectedThumbs[0].metadata.annotationFinal.userName === userObject.userName &&
                                    canModifyDocument &&
                                    <Tooltip title={t("Remove marked as final document")} placement="top" enterDelay={1000}>
                                        <IconButton onClick={() => openConfirmSaveUnfinal()} size="large">
                                            <FinalAnnotationIcon className={classes.smallerIconRed}/>
                                        </IconButton>
                                    </Tooltip>
                                    }
                                </div>
                                }

                                <Popper className={classes.popper} open={isDownloadDropDownOpen}
                                        placement="bottom-start"
                                        anchorEl={anchorRefDownload.current} role={undefined} transition
                                        disablePortal>
                                    {({TransitionProps, placement}) => (
                                        <Grow {...TransitionProps}>
                                            <Paper>
                                                <ClickAwayListener onClickAway={closeDownloadDropDown}>
                                                    <div>
                                                        <MenuList>
                                                            <MenuItem
                                                                className={classes.listElement}
                                                                onClick={downloadSelectedDocuments}
                                                            >
                                                                Download Original File
                                                            </MenuItem>
                                                            <MenuItem
                                                                className={classes.listElement}
                                                                onClick={()=>downloadSelectedPDFDocuments("inline")}
                                                            >
                                                                Open as a Report
                                                            </MenuItem>
                                                            <MenuItem
                                                                className={classes.listElement}
                                                                onClick={()=>downloadSelectedPDFDocuments("attachment")}
                                                            >
                                                                Download as a Report
                                                            </MenuItem>

                                                            <MenuItem
                                                                className={classes.listElement}
                                                                disabled={(selectedThumbs.length > 1 || selectedThumbs[0]?.__isStudy)}
                                                                onClick={printImageWithAnnotations}
                                                            >
                                                                Print
                                                            </MenuItem>
                                                        </MenuList>
                                                    </div>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>

                                {patientObject && patientObject.hospitalNumber &&
                                <UploadIMAGE
                                    open={uploadVisible}
                                    studyId={(selectedThumbs.length === 1 && selectedThumbs[0].__isStudy) ? selectedThumbs[0].study : null}
                                    onUploadCancel={uploadCancel} onUploadFinished={uploadFinished}
                                    patientId={patientObject.hospitalNumber} />
                                }

                            </div>
                        </Grid>
                        <Grid item>
                            {!isStudiesListOpen &&
                            <Button size="small" style={{minWidth: "0"}} className={classes.button}
                                    onClick={handleSizeChange}>
                                {thumbnailSize === "small" &&
                                <Tooltip title={t("Large thumbnails")} placement="top" enterDelay={1000}>
                                    <PhotoIcon className={classes.sizeIcon}/>
                                </Tooltip>
                                }
                                {thumbnailSize === "big" &&
                                <Tooltip title={t("Small thumbnails")} placement="top" enterDelay={1000}>
                                    <PhotoSizeSelectLargeIcon className={classes.sizeIcon}/>
                                </Tooltip>
                                }
                            </Button>
                            }
                            {isStudiesListOpen && filtersListAreSet() &&
                            <div onClick={clearFiltersAndSorts} style={{display: "inline"}} className={classes.groupedButton}>
                                Clear All
                            </div>
                            }
                            {isStudiesListOpen && filtersListAreActive() &&
                            <div  className={classes.switchContainer}>
                                Exact
                                <SwitchT checked={filterListTypeContain}
                                         size={"small"}
                                         classes={{track: classes.SwitchTrack}}
                                         onChange={(e)=>{setFilterListTypeContain(e.target.checked)}} color="tertiary" />
                                Contain
                            </div>
                            }
                            {!isStudiesListOpen &&
                            <Tooltip title={t("Studies List Compacted")} placement="top" enterDelay={1000}>
                                <Button size="small" style={{minWidth: "0"}} className={classes.button}
                                        onClick={openStudiesList}>
                                    <StudyListIcon className={classes.sizeIcon}/>
                                </Button>
                            </Tooltip>
                            }
                            {isStudiesListOpen &&
                            <Tooltip title={t("Studies List With Thumbnails")} placement="top" enterDelay={1000}>
                                <Button size="small" style={{minWidth: "0"}} className={classes.button}
                                        onClick={()=> {closeStudiesList()}}>
                                    <StudyListIcon2 className={classes.sizeIcon}/>
                                </Button>
                            </Tooltip>
                            }
                            {/*<Button className={classes.buttonStudies} variant={"outlined"} onClick={openStudiesList}>*/}
                            {/*    Studies List*/}
                            {/*</Button>*/}
                        </Grid>
                    </Grid>
                    {isStudiesListOpen &&  <div >
                        <Paper className={classes.studyElementPaper}>
                            <div className={clsx([classes.studyElementContentHeader, classes.studyHeader])}>
                                <Grid container alignItems={"stretch"}>
                                    <Grid item xs={2} style={{textAlign: "center"}}>
                                        {renderListHeaderItem("date","Date", true)}
                                    </Grid>
                                    <Grid item xs={1}>
                                        {renderListHeaderItem("image","Image", true)}
                                    </Grid>
                                    <Grid item xs={3}>
                                        {renderListHeaderItem("type","Type")}
                                    </Grid>
                                    <Grid item xs={3}>
                                        {renderListHeaderItem("location","Location")}
                                    </Grid>
                                    <Grid item xs={3}>
                                        {renderListHeaderItem("operator","Operator")}
                                    </Grid>
                                </Grid>
                            </div>
                        </Paper>
                    </div>
                    }
                </div>}
            </div>
            }

            {!loadingPatientObject && !loadingDocumentObject &&
            <div id="studiesListContainer" style={{ position: "relative", height: `calc(100% - ${topBarRef.current?.clientHeight}px)` }}>
                <div  id='studiesList' className={"scroll-normal-white"} style={{ height: `calc(100%)` , overflow: "auto"}}>

                    {studiesListRender && studiesListRender.length > 0 && [...studiesListRender]}
                    {(!studiesListRender || studiesListRender.length === 0) && patientObject &&
                    <div className={classes.noRecordsInfo}>
                        {filtersAreSet() ? t("No files for set filters") : t("No files exist for this patient yet")}
                    </div>
                    }
                    {!patientObject &&
                    <div className={classes.noRecordsInfo}>
                        {canViewPatientRecord ? t("Patient ID does not exist in the database") : t("User has no access to the patient record")}
                    </div>
                    }
                </div>
            </div>
            }
        </div>
    );
}

export default Patient